import * as countryService from '/source/js/services/countryService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';

const RADIO_CHECKED = 'language-radio__label-checked';
const DD_SELECTED = 'select-box__selected';
const DD_FOCUSED = 'select-dropdown__is-focused ';
const CURR_REGION = $("input[name='Region']:checked").val();
const CURR_LANG = $("input[name='langSelection']:checked").val();
let catalogSelectorData;
var isRecommendedCartFlow = document.querySelector('.recommended-cart');

function selectedRadio() {
    let $radioLabel = $('.language-radio__label');
    let $radioInput = $('input.language-radio__input');

    $radioLabel.click(function (e) {
        e.stopPropagation();
        let $this = $(this);
        if($radioInput.is(':checked')) {
            $radioLabel.removeClass(RADIO_CHECKED);
            $this.addClass(RADIO_CHECKED);
        }
    });
}

export function showAlerts() {
    $('.alert--order').show();
    $('.alert--country').show();
}

export function clearAlerts() {
    $('.alert--order').hide();
    $('.alert--country').hide();
    $('.alert--orderType').hide();
}

function countryDropDown() {
    let $selectButton = $('.select-box__current');
    let $ddContainer = $('.select-dropdown');
    let $ddList = $('.select-box__list');
    let $ddSelection = $('.select-box__option');

    if(isRecommendedCartFlow !== null) {
        $('.select-box__current').addClass('hide-dropdown');
    }

    $selectButton.click(function () {
        if($ddList.is(':hidden')) {
            if(isRecommendedCartFlow == null) {
                $ddList.show();
                $ddContainer.addClass(DD_FOCUSED);
                return false;
            }
        } else {
            $ddList.hide();
        }
    });

    $(document).click(function() {
        $ddContainer.removeClass(DD_FOCUSED);
        $ddList.hide();
    });

    $ddList.click(function(e) {
        $ddContainer.addClass(DD_FOCUSED);
        e.stopPropagation();
    });

    $ddSelection.click(function() {
        let $this = $(this);
        $ddSelection.removeClass(DD_SELECTED);
        $this.addClass(DD_SELECTED);
        $('.alert--country').show();
        handleLanguageSelection($(this).attr('value'));
    });
}

function handleLanguageSelection(currentCountryRadioValue) {
    $('[id ^= LangRadioLabel]').hide();

    if(currentCountryRadioValue !== CURR_REGION) {
        var currCartItems = document.getElementById('hidden-cartItem-count');
        if(currCartItems && currCartItems.value > 0) {
            showAlerts();
        } else {
            clearAlerts();
        }
    } else {
        clearAlerts();
    }

    var allLangRadioElements = document.querySelectorAll('[id^=LangRadioLabel]');
    var currentCountryLanguages = document.getElementById('hdnFlag' + currentCountryRadioValue);
    if(!currentCountryLanguages) return;

    var languagesString = currentCountryLanguages.value;
    let defaultLanguageSelected = false;

    for (var i = 0; i < allLangRadioElements.length; i++) {
        if(languagesString.includes(allLangRadioElements[i].firstElementChild.value)) {
            let $langRadioLabel = $('#LangRadioLabel' + allLangRadioElements[i].firstElementChild.value);

            $langRadioLabel.show();
            if(languagesString.trim().split(' ').length === 1 || allLangRadioElements[i].firstElementChild.value === CURR_LANG) {
                $langRadioLabel.trigger('click');
                defaultLanguageSelected = true;
            } else if(!defaultLanguageSelected) {
                $langRadioLabel.trigger('click');
                defaultLanguageSelected = true;
            }
        }
    }
}

function initEventHandlers() {
    let $catalogSelector = $('.catalogSelectorModal');
    catalogSelectorData = $catalogSelector.data('catalog-selector');
    if(catalogSelectorData) { return; }
    countryDropDown();
    if(window.location.href.toLowerCase().includes('brand-partner-benefits')) {
        $('[data-hide-for-bp="True"]').hide();
    }
    selectedRadio();
    clearAlerts();
    $('.close').on('click', clearAlerts);
    var currentCountry = $("input[name='Region']:checked").val();
    handleLanguageSelection(currentCountry);
    $('#SubmitCountryButton').click(async function () {
        loadSpinner();
        window.sessionStorage.setItem('cultureChanged', 'true');
        var region = $("input[name='Region']:checked").val();
        let langSelection = '';
        langSelection = $("input[name='langSelection']:checked").val();
        if(region === CURR_REGION && langSelection === CURR_LANG) {
            stopSpinner();
            $('#countryChooser').modal('hide');
            return;
        }
        const result = await countryService.changeContextForCountry(region, langSelection);
        if(result) {
            $('#countryChooser').modal('hide');
            $('#countryChooser').on('hide.bs.modal', stopSpinner);
            window.location = result;
        }
    });
}

$(function () {
    initEventHandlers();
});
